import { useLocalSearchParams } from 'expo-router';
import EventDetailSchedules from '@/screens/EventDetailSchedules';

export default function PrivateTabsEventEventIdSchedulesRoute() {
  const { eventId } = useLocalSearchParams<{ eventId: string }>();

  return <EventDetailSchedules basePath="/event/[eventId]" eventId={eventId} />;
}
